import axios from "axios";
import { toast } from "react-toastify";
import { API_ERROR_500 } from "../../../../../config";
import { setLoading, updateScreenPage } from "../../../../../redux";

export const submitPan = (
  data,
  digilocker,
  setPanInfo,
  setShowPanInfoModal,
  setKraStatus,
  history
) => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  return async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const resp = await axios.post(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.verify_pan`,
        data,
        headers
      );
      console.log("resp", resp);
      setPanInfo(resp.data?.data);
      submitKRA(
        dispatch,
        digilocker,
        setShowPanInfoModal,
        setKraStatus,
        history
      );
      toast.success("PAN Verification Successful");
    } catch (error) {
      const { response } = error || {};
      dispatch(setLoading(false));
      toast.error(response?.data?.message || API_ERROR_500);
    }
  };
};

export const submitKRA = async (
  dispatch,
  digilocker,
  setShowPanInfoModal,
  setKraStatus,
  history
) => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  try {
    await axios.post(
      `${API_URL}/api/method/kyc_customizations.apis.kra.api.check_kra_status`,
      {},
      headers
    );
    setTimeout(() => {
      downloadKRACheck(dispatch, digilocker, setShowPanInfoModal, setKraStatus, history);
    }, 3000);
  } catch (error) {
    if (digilocker) {
      dispatch(setLoading(false));
      history.push("/address");
      // dispatch(updateScreenPage());
    } else {
      dispatch(setLoading(false));
      setShowPanInfoModal((show) => !show);
    }
  }
};

export const downloadKRACheck = async (
  dispatch,
  digilocker,
  setShowPanInfoModal,
  setKraStatus,
  history
) => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  try {
    await axios.post(
      `${API_URL}/api/method/kyc_customizations.apis.kra.api.download_kra`,
      {},
      headers
    );
    dispatch(setLoading(false));
    // setKraStatus(true);
    setShowPanInfoModal((show) => !show);
  } catch (error) {
    dispatch(setLoading(false));
    if (digilocker) {
      history.push("/address");
      // dispatch(updateScreenPage());
    } else {
      getDgLocker(dispatch);
    }
  }
};

export const getDgLocker = () => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  return async (dispatch) => {
    try {
      const resp = await axios.get(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.get_digilocker_url`,
        headers
      );
      window.localStorage.setItem("dlocker", "done");
      window.location.href = resp?.data?.data?.url;
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
    }
  };
};
